// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.publish-scenario-tab .cds--accordion__wrapper {
  background-color: var(--cds-background);
}
.publish-scenario-tab .cds--accordion__wrapper .cds--accordion__content {
  padding-inline-end: 1rem !important;
}
.publish-scenario-tab .cds--data-table-header {
  padding-block-end: 0.5rem;
}
.publish-scenario-tab .cds--data-table-header > p {
  max-inline-size: 100%;
}
.publish-scenario-tab .publish-table-description {
  display: flex;
  align-items: center;
  background-color: var(--cds-layer);
  padding: 0 1rem;
}
.publish-scenario-tab .publish-table-description > p:first-child {
  flex: 1 0 auto;
  height: fit-content;
}
.publish-scenario-tab .table-row-scenario-name {
  display: flex;
  align-items: center;
  height: inherit;
  text-wrap: nowrap;
}
.publish-scenario-tab .table-row-scenario-review {
  height: fit-content;
  min-height: fit-content;
}
.publish-scenario-tab .accordion-title {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  margin: 1rem 0;
  align-items: center;
}
.publish-scenario-tab .accordion-title > div {
  font-size: 1.1rem;
  height: fit-content;
}
.publish-scenario-tab .publish-filters .tables {
  display: flex;
  margin: 0 0 2rem 0;
  max-height: 24rem;
  gap: 10rem;
}
.publish-scenario-tab .publish-filters .tables > div {
  width: 100%;
}
.publish-scenario-tab .publish-filters .tables .cds--data-table-header {
  padding-left: 0.5rem;
}
.publish-scenario-tab .publish-filters > h4 {
  padding-left: 0.5rem;
}
.publish-scenario-tab .filter-dropdowns {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.publish-scenario-tab .filter-dropdowns > div {
  padding-right: 2rem;
  width: 100%;
}
.publish-scenario-tab .publish-confirmation-modal .cds--modal-content {
  min-height: 12rem;
}
.publish-scenario-tab .scenario-toast-notification--container {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 1;
}
.publish-scenario-tab .scenario-toast-notification--container > div {
  max-width: 38rem;
  flex-direction: column;
}
.publish-scenario-tab .publish-table .highlight {
  background: #FFBF00 !important;
  color: #000 !important;
}
.publish-scenario-tab .publish-table .highlight .table-row-scenario-review {
  color: #000 !important;
  font-weight: 700;
}
.publish-scenario-tab .publish-table .highlight td {
  color: #000 !important;
}
.publish-scenario-tab .publish-table .highlight:hover {
  color: #000 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/PublishScenarioTab/PublishScenarioTab.scss"],"names":[],"mappings":"AACI;EACI,uCAAA;AAAR;AAEQ;EACI,mCAAA;AAAZ;AAII;EACI,yBAAA;AAFR;AAIQ;EACI,qBAAA;AAFZ;AAMI;EACI,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,eAAA;AAJR;AAMQ;EACI,cAAA;EACA,mBAAA;AAJZ;AAQI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AANR;AASI;EACI,mBAAA;EACA,uBAAA;AAPR;AAUI;EACI,aAAA;EACA,kCAAA;EACA,WAAA;EAEA,cAAA;EACA,mBAAA;AATR;AAaQ;EACI,iBAAA;EACA,mBAAA;AAXZ;AAgBQ;EACI,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;AAdZ;AAgBY;EACI,WAAA;AAdhB;AAiBY;EACI,oBAAA;AAfhB;AAmBQ;EACI,oBAAA;AAjBZ;AAqBI;EACI,aAAA;EACA,kCAAA;AAnBR;AAqBQ;EACI,mBAAA;EACA,WAAA;AAnBZ;AAwBQ;EACI,iBAAA;AAtBZ;AA0BI;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AAxBR;AA0BQ;EACI,gBAAA;EACA,sBAAA;AAxBZ;AA6BQ;EACI,8BAAA;EACA,sBAAA;AA3BZ;AA6BY;EACI,sBAAA;EACA,gBAAA;AA3BhB;AA8BY;EACI,sBAAA;AA5BhB;AA+BY;EACI,sBAAA;AA7BhB","sourcesContent":[".publish-scenario-tab {\n    .cds--accordion__wrapper {\n        background-color: var(--cds-background);\n\n        .cds--accordion__content {\n            padding-inline-end: 1rem !important;\n        }\n    }\n\n    .cds--data-table-header {\n        padding-block-end: 0.5rem;\n\n        &>p {\n            max-inline-size: 100%;\n        }\n    }\n\n    .publish-table-description {\n        display: flex;\n        align-items: center;\n        background-color: var(--cds-layer);\n        padding: 0 1rem;\n\n        &>p:first-child {\n            flex: 1 0 auto;\n            height: fit-content;\n        }\n    }\n\n    .table-row-scenario-name {\n        display: flex;\n        align-items: center;\n        height: inherit;\n        text-wrap: nowrap;\n    }\n\n    .table-row-scenario-review {\n        height: fit-content;\n        min-height: fit-content;\n    }\n\n    .accordion-title {\n        display: grid;\n        grid-template-columns: 1fr 1fr 1fr;\n        width: 100%;\n        // height: 3rem;\n        margin: 1.0rem 0;\n        align-items: center;\n\n        // justify-content: space-between;\n        // max-width: 75%;\n        &>div {\n            font-size: 1.1rem;\n            height: fit-content;\n        }\n    }\n\n    .publish-filters {\n        .tables {\n            display: flex;\n            margin: 0 0 2rem 0;\n            max-height: 24rem;\n            gap: 10rem;\n\n            &>div {\n                width: 100%;\n            }\n\n            .cds--data-table-header {\n                padding-left: 0.5rem;\n            }\n        }\n\n        &>h4 {\n            padding-left: 0.5rem;\n        }\n    }\n\n    .filter-dropdowns {\n        display: grid;\n        grid-template-columns: 1fr 1fr 1fr;\n\n        &>div {\n            padding-right: 2rem;\n            width: 100%;\n        }\n    }\n\n    .publish-confirmation-modal {\n        .cds--modal-content {\n            min-height: 12rem;\n        }\n    }\n\n    .scenario-toast-notification--container {\n        position: fixed;\n        bottom: 2rem;\n        right: 2rem;\n        z-index: 1;\n\n        &>div {\n            max-width: 38rem;\n            flex-direction: column;\n        }\n    }\n\n    .publish-table {\n        & .highlight {\n            background: #FFBF00 !important;\n            color: #000 !important;\n\n            & .table-row-scenario-review {\n                color: #000 !important;\n                font-weight: 700;\n            }\n\n            & td {\n                color: #000 !important;\n            }\n\n            &:hover {\n                color: #000 !important;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
